import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchBooksQuery } from '../../features/api/apiSlice';
import { toggleFilter } from '../../features/filter/filterSlice';
import Error from '../shared/ui/Error';
import Loading from '../shared/ui/Loading';
import BookGridItem from './BookGridItem';

const BookGrid = () => {
    const dispatch = useDispatch();
    const {data:books, isLoading, isError} = useFetchBooksQuery();
    const {filter, searchKeyword} = useSelector((state) => state.filter);

    let content;

    if(isLoading){
        content = <Loading />
    }

    if(!isLoading && isError){
        content = <Error />
    }

    if(!isLoading && !isError && books.length === 0){
        content = <h3>No books available</h3>
    }

    if(!isLoading && !isError && books.length > 0){
        content = books
        .filter((book) => {
            if(filter === "Featured"){
                return book.featured
            }
            return true;
        })
        .filter((book) => {
            if(searchKeyword){
               return book.name.toLowerCase().includes(searchKeyword.toLowerCase());
            }
            return true;
        })
        .map((book) => <BookGridItem key={book.id} book={book}/>)
    }
    return (     
    <div class="order-2 xl:-order-1">
      <div class="flex items-center justify-between mb-12">
        <h4 class="mt-2 text-xl font-bold">Book List</h4>

        <div class="flex items-center space-x-4">
          <button class={`lws-filter-btn ${filter === "All" ? "active-filter" : ""}`} onClick={() => dispatch(toggleFilter("All"))}>All</button>
          <button class={`lws-filter-btn ${filter === "Featured" ? "active-filter" : ""}`} onClick={() => dispatch(toggleFilter("Featured"))}>Featured</button>
        </div>
      </div>
      <div class="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
       {content}
      </div>
    </div>
    );
};

export default BookGrid;